import { DamageC1CodeResponse } from "../../api-models/response/DamageMainCodeResponse";

export class DamageC1Code implements DamageC1CodeResponse {
  code: string;
  text: string;
  hasC2Code: boolean;

  constructor(damageC1Code: DamageC1CodeResponse, public isValid: boolean) {
    this.code = damageC1Code.code;
    this.text = damageC1Code.text;
    this.hasC2Code = damageC1Code.hasC2Code;
  }

  setText(newText: string) {
    this.text = newText;
  }

  public get label() {
    return `${this.code} ${this.text}`;
  }
}

export const emptyC1Code = new DamageC1Code(
  {
    code: "emptyCode",
    text: "",
    hasC2Code: false,
  },
  false
);
